import * as superagent from 'superagent';

export interface IUserBcErrorRequestData {
  businessShoppingCenterId: number;
  message: string;
  email: string;
  userId?: number;
};

export default function sendUserBcError(data: IUserBcErrorRequestData): Promise<any> {
  return new Promise((resolve, reject) => {
    superagent
      .post('/addform/v2/bs_centers/feedback/')
      .send(data)
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err) {
          reject(err);
          return;
        }

        if (res.status === 204 && res.ok) {
          resolve();
          return;
        }

        reject(new Error(`Unexpected Network Error: ${res.status}`));
      });
  });
}



// WEBPACK FOOTER //
// ./src/api/user_bc_error.ts